import {
  SUBJECT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function Subject(state = initialState, action) {
  switch (action.type) {
    case SUBJECT.handlers.fetch:
    case SUBJECT.handlers.update:
    case SUBJECT.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case SUBJECT.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
